"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cartOperationDataReducer = cartOperationDataReducer;
exports.default = exports.cartOperationReducer = void 0;
var _simpleDataReducer = require("../../../common/utils/simpleDataReducer");
var _seamlessImmutable = _interopRequireDefault(require("seamless-immutable"));
var actions = _interopRequireWildcard(require("./actions"));
var _const = require("./const");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const addToCartReducer = (0, _simpleDataReducer.createReducer)(actions.ADD_TO_CART_API);
const updateCartReducer = (0, _simpleDataReducer.createReducer)(actions.UPDATE_PRODUCT_QUANTITY_API);
const getCartReducer = (0, _simpleDataReducer.createReducer)(actions.GET_CART_API);
const topSellingProducts = (0, _simpleDataReducer.createReducer)(actions.GET_TOP_SELLING_PRODUCT_API);
const deleteProducts = (0, _simpleDataReducer.createReducer)(actions.DELETE_ITEMS_API);
const cartProductsRecommendationReducer = (0, _simpleDataReducer.createReducer)(actions.CART_PRODUCTS_RECOMMENDATION_API);
const addToCartReducerV2 = (0, _simpleDataReducer.createReducer)(actions.ADD_TO_CART_API_V2);
const updateCartReducerV2 = (0, _simpleDataReducer.createReducer)(actions.UPDATE_PRODUCT_QUANTITY_API_V2);
const deleteProductsV2 = (0, _simpleDataReducer.createReducer)(actions.DELETE_ITEMS_API_V2);
const getCartReducerV2 = (0, _simpleDataReducer.createReducer)(actions.GET_CART_API_V2);
const fbtAddToCartReducer = (0, _simpleDataReducer.createReducer)(actions.FBT_ADD_TO_CART_API);
const getCartFillersReducer = (0, _simpleDataReducer.createReducer)(actions.GET_CART_FILLERS_API);
const asterOnlineAddToCartReducer = (0, _simpleDataReducer.createReducer)(actions.ASTER_ONLINE_ADD_TO_CART_API);
const getCartMarketBanner = (0, _simpleDataReducer.createReducer)(actions.GET_CART_MARKETING_BANNER_API);
const addItemsToCartReducer = (0, _simpleDataReducer.createReducer)(actions.ADD_ITEMS_TO_CART_API);
const updateItemsToCartReducer = (0, _simpleDataReducer.createReducer)(actions.UPDATE_ITEMS_IN_CART);
const removeItemsFromCartReducer = (0, _simpleDataReducer.createReducer)(actions.REMOVE_ITEM_FROM_CART);
const removeMultipeItemsFromCartReducer = (0, _simpleDataReducer.createReducer)(actions.REMOVE_MULTIPLE_ITEMS_FROM_CART);

/**
 * New Cart Reducer for Api which provides merge response of CartInfo and CartInfoDetail
 * **/

const getCommonServiceCartData = (0, _simpleDataReducer.createReducer)(actions.GET_COMMON_SERVICE_CART_DATA_API);
const getCartDetails = (0, _simpleDataReducer.createReducer)(actions.GET_CART_DETAILS_API);
const createRxCart = (0, _simpleDataReducer.createReducer)(actions.CREATE_RX_CART_API);
const mergeCartDetails = (0, _simpleDataReducer.createReducer)(actions.MERGE_CART_DETAILS_API);

/**
 * cart_operation initial state
 * add_to_cart_count: 0
 * update_to_cart_count: 0
 */
const initialState = (0, _seamlessImmutable.default)({
  add_to_cart_count: 0,
  update_to_cart_count: 0
});
function cartOperationDataReducer(state, action) {
  const finalState = state !== null && state !== void 0 ? state : initialState;
  switch (action.type) {
    case actions.SET_CART_OPERATION_DATA:
      return {
        ...finalState,
        ...action.data
      };
    default:
      return finalState;
  }
}
var _default = exports.default = {
  [_const.ADD_TO_CART]: addToCartReducer,
  [_const.UPDATE_CART]: updateCartReducer,
  [_const.GET_CART]: getCartReducer,
  [_const.TOP_SELLING_PRODUCTS]: topSellingProducts,
  [_const.DELETE_PRODUCTS]: deleteProducts,
  [_const.CART_PRODUCTS_RECOMMENDATION]: cartProductsRecommendationReducer,
  [_const.ADD_TO_CART_V2]: addToCartReducerV2,
  [_const.UPDATE_CART_V2]: updateCartReducerV2,
  [_const.DELETE_PRODUCTS_V2]: deleteProductsV2,
  [_const.GET_CART_V2]: getCartReducerV2,
  [_const.FBT_ADD_TO_CART]: fbtAddToCartReducer,
  [_const.CART_FILLERS]: getCartFillersReducer,
  [_const.ASTER_ONLINE_ADD_TO_CART]: asterOnlineAddToCartReducer,
  [_const.GET_COMMON_SERVICE_CART_DATA]: getCommonServiceCartData,
  [_const.GET_CART_MARKETING_BANNER]: getCartMarketBanner,
  [_const.GET_CART_DETAILS]: getCartDetails,
  [_const.CREATE_RX_CART]: createRxCart,
  [_const.ADD_ITEMS_TO_CART]: addItemsToCartReducer,
  [_const.UPDATE_ITEMS_IN_CART]: updateItemsToCartReducer,
  [_const.REMOVE_ITEM_FROM_CART]: removeItemsFromCartReducer,
  [_const.REMOVE_MULTIPLE_ITEMS_FROM_CART]: removeMultipeItemsFromCartReducer,
  [_const.MERGE_CART_DETAILS]: mergeCartDetails
};
const cartOperationReducer = exports.cartOperationReducer = {
  [_const.CART_OPERATION_DATA]: cartOperationDataReducer
};